export default {
    createFreeAccount: 'Sign Up for MyFreeCams',
    login: 'Log In',
    logout: 'Log Out',
    mustBeLoggedIn: 'You must be logged in to ',
    username: 'Username',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    noAccount: 'Not a member? ',
}
